import LinkButton from '@sats-group/ui-lib/react/link-button';
import PricingCard from '@sats-group/ui-lib/react/pricing-card';
import React from 'react';
import Carousel from '~/client/components/carousel/carousel';
import PreviewCard from '~/client/components/preview-card/preview-card';
import ProfileCards from '~/client/components/profile-cards/profile-cards';
import type { View as SegmentedSectionView } from '~/client/components/segmented-section/segmented-section.types';
import type {
  BecomeMemberView,
  ConceptsView,
  TeamView,
} from './club-page.types';

export const toBecomeMemberSegmentedSectionView = ({
  segments,
  ...view
}: BecomeMemberView): SegmentedSectionView => ({
  ...view,
  segments: segments.map(({ memberships, ...segment }) => ({
    ...segment,
    slot: (
      <div className="club-page__member-type-cards club-page__member-type-cards--animated">
        {memberships.map(membership => (
          <PricingCard key={membership.id} {...membership} />
        ))}
      </div>
    ),
  })),
});

export const toConceptsSegmentedSectionView = ({
  segments,
  ...view
}: ConceptsView): SegmentedSectionView => ({
  ...view,
  segments: segments.map(({ carousel, seeAllLink, ...segment }) => ({
    ...segment,
    slot: (
      <div className="club-page__concepts">
        <Carousel {...carousel} entryRenderer={PreviewCard} />
        {seeAllLink ? (
          <LinkButton
            className="club-page__concepts-see-all"
            variant={LinkButton.variants.secondary}
            {...seeAllLink}
          />
        ) : null}
      </div>
    ),
  })),
});

export const toTeamSegmentedSectionView = ({
  segments,
  ...view
}: TeamView): SegmentedSectionView => ({
  ...view,
  segments: segments.map(({ profiles, seeAllLink, ...segment }) => ({
    ...segment,
    slot: (
      <div className="club-page__team-cards">
        <ProfileCards profiles={profiles} />
        {seeAllLink ? (
          <LinkButton
            className="club-page__team-see-all"
            variant={LinkButton.variants.secondary}
            {...seeAllLink}
          />
        ) : null}
      </div>
    ),
  })),
});
